import { Avatar, Button, H5, Popover } from "@datapay-by-datacom/design-system";
import { useAuthenticated } from "../../authn/hooks";
import { useRef, useState } from "react";
import { getSupportLink, getTermsUrl } from "../../brand-config";
import { getAuth0LogoutReturnTo } from "../../shared/functions";
import s from "./Profile.module.css";

export function Profile() {
  const { user, logout } = useAuthenticated();
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);

  const logoutAction = () => {
    logout({
      logoutParams: {
        returnTo: getAuth0LogoutReturnTo(),
      },
    });
  };

  const name = user.name || user.given_name || user.email || "";

  return (
    <>
      <div ref={triggerRef} className={s.profile}>
        <Avatar
          value={{
            type: "user",
            name,
          }}
          imgSrc={user.picture}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <Popover
        triggerRef={triggerRef}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        placement="right"
      >
        <div className={s.profileMenu}>
          <H5>{name}</H5>
          <p>{user.email}</p>
          <Button variant="secondary" onPress={logoutAction}>
            Logout
          </Button>
          <div className={s.links}>
            <a href={getTermsUrl()} target="_blank">
              Terms and Conditions
            </a>
            <a href={getSupportLink()}>Support</a>
          </div>
        </div>
      </Popover>
    </>
  );
}
